// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { toast } from "react-toastify";
// import { API_BASE_URL } from "../../config/api";

// const CheckoutAddressForm = ({
//   deliveryAddress,
//   handleAddressChange,
//   handleSubmit,
//   handlePrevStep,
//   loading,
//   setSelectedAddressId,
// }) => {
//   const [addresses, setAddresses] = useState([]);
//   const [selectedAddressId, setLocalSelectedAddressId] = useState(null);
//   const [isAddingNewAddress, setIsAddingNewAddress] = useState(false);
//   const [fetchLoading, setFetchLoading] = useState(false);
//   const jwt = localStorage.getItem("jwt");

//   useEffect(() => {
//     const fetchAddresses = async () => {
//       if (!jwt) return;
//       setFetchLoading(true);
//       try {
//         // const response = await axios.get("https://ramyanbackend-production.up.railway.app/api/users/address", {
//         //   headers: { Authorization: `Bearer ${jwt}` },
//         // });


//         const response = await axios.get(
//           `${API_BASE_URL}/api/users/address`,
//           {
//             headers: { Authorization: `Bearer ${jwt}` },
//           }
//         )

//         setAddresses(response.data);

//         // Auto-select first only if NOT adding new
//         if (response.data.length > 0 && !isAddingNewAddress) {
//           const firstAddress = response.data[0];
//           setLocalSelectedAddressId(firstAddress._id);
//           setSelectedAddressId(firstAddress._id);

//           handleAddressChange({ target: { name: "firstName", value: firstAddress.firstName } });
//           handleAddressChange({ target: { name: "lastName", value: firstAddress.lastName } });
//           handleAddressChange({ target: { name: "streetAddress", value: firstAddress.streetAddress } });
//           handleAddressChange({ target: { name: "city", value: firstAddress.city } });
//           handleAddressChange({ target: { name: "state", value: firstAddress.state } });
//           handleAddressChange({ target: { name: "zipCode", value: firstAddress.zipCode } });
//           handleAddressChange({ target: { name: "mobile", value: firstAddress.mobile } });
//         }
//       } catch (error) {
//         console.error("Failed to fetch addresses:", error);
//         toast.error("Failed to load addresses. Please try again.");
//       } finally {
//         setFetchLoading(false);
//       }
//     };

//     fetchAddresses();
//   }, [jwt, isAddingNewAddress]);

//   const handleSelectAddress = (address) => {
//     setLocalSelectedAddressId(address._id);
//     setSelectedAddressId(address._id);
//     setIsAddingNewAddress(false);

//     handleAddressChange({ target: { name: "firstName", value: address.firstName } });
//     handleAddressChange({ target: { name: "lastName", value: address.lastName } });
//     handleAddressChange({ target: { name: "streetAddress", value: address.streetAddress } });
//     handleAddressChange({ target: { name: "city", value: address.city } });
//     handleAddressChange({ target: { name: "state", value: address.state } });
//     handleAddressChange({ target: { name: "zipCode", value: address.zipCode } });
//     handleAddressChange({ target: { name: "mobile", value: address.mobile } });
//   };

//   const handleAddNewAddress = () => {
//     setIsAddingNewAddress(true);
//     setLocalSelectedAddressId(null);
//     setSelectedAddressId(null);

//     // Clear all fields
//     handleAddressChange({ target: { name: "firstName", value: "" } });
//     handleAddressChange({ target: { name: "lastName", value: "" } });
//     handleAddressChange({ target: { name: "streetAddress", value: "" } });
//     handleAddressChange({ target: { name: "city", value: "" } });
//     handleAddressChange({ target: { name: "state", value: "" } });
//     handleAddressChange({ target: { name: "zipCode", value: "" } });
//     handleAddressChange({ target: { name: "mobile", value: "" } });
//   };

//   const handleFormSubmit = async (event) => {
//     event.preventDefault();
//     if (selectedAddressId && !isAddingNewAddress) {
//       await handleSubmit(event, selectedAddressId); // Only ID
//     } else {
//       await handleSubmit(event); // Full address
//     }
//   };

//   return (
//     <div className="checkout-container">
//       <h2 className="checkout-heading">DELIVERY ADDRESS</h2>

//       {fetchLoading ? (
//         <div style={{ display: "flex", justifyContent: "center", height: "20vh" }}>
//           <span>Loading addresses...</span>
//         </div>
//       ) : (
//         <>
//           {addresses.length > 0 && !isAddingNewAddress && (
//             <div className="address-list">
//               <h3>Saved Addresses</h3>
//               <form onSubmit={handleFormSubmit}>
//                 {addresses.map((address) => (
//                   <label
//                     key={address._id}
//                     className="address-item"
//                     style={{
//                       display: "block",
//                       border:
//                         selectedAddressId === address._id ? "2px solid #007bff" : "1px solid #ccc",
//                       padding: "10px",
//                       marginBottom: "10px",
//                       borderRadius: "5px",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <input
//                       type="radio"
//                       name="selectedAddress"
//                       value={address._id}
//                       checked={selectedAddressId === address._id}
//                       onChange={() => handleSelectAddress(address)}
//                       style={{ marginRight: "10px" }}
//                     />
//                     <div>
//                       <strong>{address.firstName} {address.lastName}</strong>
//                       <p>{address.streetAddress}</p>
//                       <p>{address.city}, {address.state} {address.zipCode}</p>
//                       <p>Phone: {address.mobile}</p>
//                     </div>
//                   </label>
//                 ))}

//                 <button
//                   type="submit"
//                   className="deliver-btn"
//                   disabled={loading}
//                   style={{ marginTop: "10px" }}
//                 >
//                   {loading ? "Processing..." : "Proceed to Payment"}
//                 </button>
//               </form>
//             </div>
//           )}

//           <button
//             type="button"
//             className="add-new-address-btn"
//             onClick={handleAddNewAddress}
//             style={{
//               margin: "10px 0",
//               padding: "10px",
//               backgroundColor: "#28a745",
//               color: "#fff",
//               border: "none",
//               borderRadius: "5px",
//               cursor: "pointer",
//             }}
//           >
//             Add New Address
//           </button>
//             <button type="button" className="back-to-cart-btn" onClick={handlePrevStep}>
//                   ← Back to Cart
//                 </button>
//           {isAddingNewAddress && (
//             <form className="address-form" onSubmit={handleFormSubmit}>
//               <div className="form-group">
//                 <label className="form-label required-field">First Name</label>
//                 <input
//                   type="text"
//                   name="firstName"
//                   value={deliveryAddress.firstName}
//                   onChange={handleAddressChange}
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="form-label">Last Name</label>
//                 <input
//                   type="text"
//                   name="lastName"
//                   value={deliveryAddress.lastName}
//                   onChange={handleAddressChange}
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="form-label required-field">Street Address</label>
//                 <input
//                   type="text"
//                   name="streetAddress"
//                   value={deliveryAddress.streetAddress}
//                   onChange={handleAddressChange}
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="form-label required-field">City</label>
//                 <input
//                   type="text"
//                   name="city"
//                   value={deliveryAddress.city}
//                   onChange={handleAddressChange}
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="form-label required-field">State</label>
//                 <input
//                   type="text"
//                   name="state"
//                   value={deliveryAddress.state}
//                   onChange={handleAddressChange}
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="form-label required-field">Zip Code</label>
//                 <input
//                   type="text"
//                   name="zipCode"
//                   value={deliveryAddress.zipCode}
//                   onChange={handleAddressChange}
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="form-label required-field">Mobile</label>
//                 <input
//                   type="tel"
//                   name="mobile"
//                   value={deliveryAddress.mobile}
//                   onChange={handleAddressChange}
//                   required
//                 />
//               </div>

//               <div className="checkout-footer">
//                 <button type="button" className="back-to-cart-btn" onClick={handlePrevStep}>
//                   ← Back to Cart
//                 </button>
//                 <button type="submit" className="deliver-btn" disabled={loading}>
//                   {loading ? "Processing..." : "Proceed to Payment"}
//                 </button>
//               </div>
//             </form>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default CheckoutAddressForm;


import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../config/api";

const FIELDS = [
  { name: "firstName",     label: "First Name",     type: "text" },
  { name: "lastName",      label: "Last Name",      type: "text" },
  { name: "streetAddress", label: "Street Address", type: "text" },
  { name: "city",          label: "City",           type: "text" },
  { name: "state",         label: "State",          type: "text" },
  { name: "zipCode",       label: "Zip Code",       type: "tel"  },
  { name: "mobile",        label: "Mobile Number",  type: "tel"  },
];

function validate(deliveryAddress) {
  const errs = {};
  if (!deliveryAddress.firstName?.trim())      errs.firstName     = "First name is required";
  if (!deliveryAddress.lastName?.trim())       errs.lastName      = "Last name is required";
  if (!deliveryAddress.streetAddress?.trim())  errs.streetAddress = "Street address is required";
  if (!deliveryAddress.city?.trim())           errs.city          = "City is required";
  if (!deliveryAddress.state?.trim())          errs.state         = "State is required";
  if (!deliveryAddress.zipCode?.trim())        errs.zipCode       = "Zip code is required";
  else if (!/^\d{6}$/.test(deliveryAddress.zipCode))   errs.zipCode = "Must be 6 digits";
  if (!deliveryAddress.mobile?.trim())         errs.mobile        = "Mobile number is required";
  else if (!/^\d{10}$/.test(deliveryAddress.mobile))   errs.mobile  = "Must be 10 digits";
  return errs;
}

const CheckoutAddressForm = ({
  deliveryAddress,
  handleAddressChange,
  handleSubmit,
  handlePrevStep,
  loading,
  setSelectedAddressId,
}) => {
  const [addresses, setAddresses]                   = useState([]);
  const [selectedAddressId, setLocalSelectedAddressId] = useState(null);
  const [isAddingNewAddress, setIsAddingNewAddress] = useState(false);
  const [fetchLoading, setFetchLoading]             = useState(false);
  const [touched, setTouched]                       = useState({});
  const [submitAttempted, setSubmitAttempted]       = useState(false);

  const jwt    = localStorage.getItem("jwt");
  const errors = validate(deliveryAddress);
  const isValid = Object.keys(errors).length === 0;

  const showError = (name) =>
    (touched[name] || submitAttempted) && errors[name];

  useEffect(() => {
    const fetchAddresses = async () => {
      if (!jwt) return;
      setFetchLoading(true);
      try {
        const response = await axios.get(`${API_BASE_URL}/api/users/address`, {
          headers: { Authorization: `Bearer ${jwt}` },
        });
        setAddresses(response.data);
        if (response.data.length > 0 && !isAddingNewAddress) {
          const first = response.data[0];
          setLocalSelectedAddressId(first._id);
          setSelectedAddressId(first._id);
          Object.entries(first).forEach(([key, value]) =>
            handleAddressChange({ target: { name: key, value } })
          );
        }
      } catch (error) {
        console.error("Failed to fetch addresses:", error);
        toast.error("Failed to load addresses. Please try again.");
      } finally {
        setFetchLoading(false);
      }
    };
    fetchAddresses();
  }, [jwt, isAddingNewAddress]);

  const handleBlur = (name) =>
    setTouched((prev) => ({ ...prev, [name]: true }));

  const handleSelectAddress = (address) => {
    setLocalSelectedAddressId(address._id);
    setSelectedAddressId(address._id);
    setIsAddingNewAddress(false);
    Object.entries(address).forEach(([key, value]) =>
      handleAddressChange({ target: { name: key, value } })
    );
  };

  const handleAddNewAddress = () => {
    setIsAddingNewAddress(true);
    setLocalSelectedAddressId(null);
    setSelectedAddressId(null);
    setTouched({});
    setSubmitAttempted(false);
    Object.keys(deliveryAddress).forEach((key) =>
      handleAddressChange({ target: { name: key, value: "" } })
    );
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setSubmitAttempted(true);
    if (!isValid) return;
    if (selectedAddressId && !isAddingNewAddress) {
      await handleSubmit(event, selectedAddressId);
    } else {
      await handleSubmit(event);
    }
  };

  return (
    <div className="checkout-container">
      <h2 className="checkout-heading">Delivery Address</h2>

      {fetchLoading ? (
        <div className="addr-loading">
          <span>Loading saved addresses…</span>
        </div>
      ) : (
        <>
          {/* ── Saved address list ── */}
          {addresses.length > 0 && !isAddingNewAddress && (
            <form onSubmit={handleFormSubmit}>
              <p className="addr-section-label">Saved addresses</p>
              <div className="address-list">
                {addresses.map((address) => (
                  <label
                    key={address._id}
                    className={`address-item${selectedAddressId === address._id ? " selected" : ""}`}
                  >
                    <input
                      type="radio"
                      name="selectedAddress"
                      value={address._id}
                      checked={selectedAddressId === address._id}
                      onChange={() => handleSelectAddress(address)}
                    />
                    <div className="address-item-body">
                      <strong>{address.firstName} {address.lastName}</strong>
                      <span>{address.streetAddress}</span>
                      <span>{address.city}, {address.state} – {address.zipCode}</span>
                      <span>📞 {address.mobile}</span>
                    </div>
                  </label>
                ))}
              </div>
              <button type="submit" className="deliver-btn" disabled={loading}>
                {loading ? "Processing…" : "Proceed to Payment →"}
              </button>
            </form>
          )}

          {/* ── Action row ── */}
          <div className="addr-action-row">
            <button type="button" className="addr-add-btn" onClick={handleAddNewAddress}>
              + Add New Address
            </button>
            <button type="button" className="back-to-cart-btn" onClick={handlePrevStep}>
              ← Back to Cart
            </button>
          </div>

          {/* ── New address form ── */}
          {isAddingNewAddress && (
            <form className="address-form" onSubmit={handleFormSubmit} noValidate>
              <p className="addr-section-label">New address</p>

              <div className="name-fields">
                {FIELDS.slice(0, 2).map((field) => (
                  <div className="form-group" key={field.name}>
                    <label className="form-label required-field">{field.label}</label>
                    <input
                      className={`form-input${showError(field.name) ? " input-error" : ""}`}
                      type={field.type}
                      name={field.name}
                      value={deliveryAddress[field.name] || ""}
                      onChange={handleAddressChange}
                      onBlur={() => handleBlur(field.name)}
                      placeholder={field.label}
                    />
                    {showError(field.name) && (
                      <span className="field-error">{errors[field.name]}</span>
                    )}
                  </div>
                ))}
              </div>

              {FIELDS.slice(2).map((field) => (
                <div className="form-group" key={field.name}>
                  <label className="form-label required-field">{field.label}</label>
                  <input
                    className={`form-input${showError(field.name) ? " input-error" : ""}`}
                    type={field.type}
                    name={field.name}
                    value={deliveryAddress[field.name] || ""}
                    onChange={handleAddressChange}
                    onBlur={() => handleBlur(field.name)}
                    placeholder={field.label}
                  />
                  {showError(field.name) && (
                    <span className="field-error">{errors[field.name]}</span>
                  )}
                </div>
              ))}

              <button type="submit" className="deliver-btn" disabled={loading}>
                {loading ? "Processing…" : "Proceed to Payment →"}
              </button>
            </form>
          )}
        </>
      )}
    </div>
  );
};

export default CheckoutAddressForm;
